// @flow

import $ from 'jquery'

export default class StartPage {
  // eslint-disable-next-line max-len
  static PRICE_URL = '/bestellprozess?tx_voltego_orders%5Baction%5D=averagePrice&tx_voltego_orders%5Bcontroller%5D=Ajax&type=1335898897'

  static _getDisplayPrice (price: number | string) {
    return Number(price).toFixed(2).replace('.', ',')
  }

  static _getDefaults() {
    const query = window.location.search
    const params = new URLSearchParams(query)

    const pFirstName = params.get('first_name')
    const utm = params.get('utm')

    if (pFirstName || utm) {
      let store = {}
      function param(name, fieldName) {
        const val = params.get(name)

        if (Array.isArray(fieldName)) {

          fieldName.forEach (e=>{
            store[e] = val
          })
        } else {
          store[fieldName] = val
        }
        //localStorage.setItem(fieldName, val )
      }
      //param("street", "vol_orders_consumptionpoint_street[0]")
      //param("nr", "vol_orders_consumptionpoint_house_number[0]")
      //param("zip", "vol_orders_consumptionpoint_postal_code[0]")

      param("first_name", "vol_orders_contract_firstname")
      param("last_name", "vol_orders_contract_lastname")
      param("email", "vol_orders_contract_email")
      param("street", ["vol_orders_contract_street", "vol_orders_consumptionpoint_street[0]"])
      param("nr", ["vol_orders_contract_house_number", "vol_orders_consumptionpoint_house_number[0]"])
      param("zip", ["vol_orders_contract_postal_code", "postal_code", "vol_orders_consumptionpoint_postal_code[0]"])
      param("city", "vol_orders_contract_city")
      param("phone","vol_orders_contract_phone")
      param("utm", "vol_orders_contract_consultant_id")


      localStorage.setItem("url_defaults", JSON.stringify(store))
    }

  }

  static async init () {
    StartPage._getDefaults()

    const businessPrice = document.querySelector('.business-api-price')
    const privatePrice = document.querySelector('.private-api-price')

    if (businessPrice || privatePrice) {
      try {
        const result = await $.get(StartPage.PRICE_URL)

        if (businessPrice && result.business) {
          businessPrice.textContent = StartPage._getDisplayPrice(result.business)
        }

        if (privatePrice && result.private) {
          privatePrice.textContent = StartPage._getDisplayPrice(result.private)
        }
      }
      catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      }
    }
  }
}
